import { Marca } from '@/types/types'
import Axios, { AxiosPromise } from 'axios'

export class MarcaService {
  fectchAllRequest (): AxiosPromise<{data: Marca[]}> {
    return Axios.get('/marcas')
  }
}
